export default "__VITE_ASSET__352836ca__"